/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Outlet, Route, Routes, Navigate } from "react-router-dom";
import Header from "../../views/layout/Header";
import HeaderHms from "../../views/layout/HeaderHms.jsx";
import Sidebar from "../../views/layout/Sidebar";
import HospitalitySidebar from "../../views/layout/SidebarHms";
import HeaderPos from "../../views/layout/HeaderPos.jsx";
import PosSidebar from "../../views/layout/SidebarPos";

import HeaderTableFlow from "../../views/layout/HeaderTableFlow.jsx";
import SidebarTableFlow from "../../views/layout/SidebarTableFlow.jsx";
import WaitlistPage from "../../views/pages/pos/Waitlist.jsx";


import HeaderChannelManager from "../../views/layout/HeaderChannelManager.jsx";
import ChannelManagerSidebar from "../../views/layout/SidebarChannelManager.jsx";
import HeaderBookingEngine from "../../views/layout/HeaderBookingEngine.jsx";
import BookingEngineSidebar from "../../views/layout/SidebarBookingEngine.jsx";


import HeaderFeedback from "../../views/layout/HeaderFeedback.jsx";
import  FeedbackSidebar from "../../views/layout/SidebarFeedback.jsx";
import  FeedbackResponses from "../../views/pages/feedback/FeedbackResponses.jsx";

import HeaderDynamicPrice from "../../views/layout/HeaderDynamicPrice.jsx";
import  SidebarDynamicPrice from "../../views/layout/SidebarDynamicPrice.jsx";



import  ChannelManagerLanding from "../../views/pages/channel-manager/ChannelManagerLanding.jsx";
import  ChannelManagerSetup from "../../views/pages/channel-manager/components/SetupWizard.jsx";
import  ChannelSettings from "../../views/pages/channel-manager/components/ChannelSettings.jsx";
import  OTAChannelSetup from "../../views/pages/channel-manager/components/OtaSettings.jsx";
import  ChannelManagerHome from "../../views/pages/channel-manager/ChannelManagerHome.jsx";
import AriGridPage from "../../views/pages/channel-manager/AriGridPage.jsx";
 import BookingDashboard from "../../views/pages/channel-manager/BookingDashboard.jsx";



import HeaderDigitalMenu from "../../views/layout/HeaderDigitalMenu.jsx";
import  DigitalMenuSidebar from "../../views/layout/SidebarDigitalMenu.jsx";

import ReservationWidgetFront from "../../views/pages/pos/widget/ReservationWidget.jsx";

import AdminReservation from "../../views/pages/restaurant-reservations/ExperienceBuilder.jsx";

//import PayrollDashboard from "../../views/pages/MainPages/Dashboard/PayrollDashboard/index.jsx";
//import ChatSidebar from "../../components/Mainpages/chatSidebar";  //SbLoJ&lHCUjk
//import ComponentSidebar from "../../components/ComponentSidebar";
//import EmailSidebar from "../../components/Mainpages/emailSidebar";
import SettingsSidebar from "../../components/SettingsSidebar";
import PrivateRoute from '../../Routes/Approuter/PrivateRoute'; // Adjust the path as needed
//import BasicInputs from "../../views/pages/Ui_Interface/Forms/BasicInputs";
//import InputGroups from "../../views/pages/Ui_Interface/Forms/InputGroups";
//import HorizontalForm from "../../views/pages/Ui_Interface/Forms/HorizontalForm";
//import VerticalForm from "../../views/pages/Ui_Interface/Forms/VerticalForm";
//import Formmask from "../../views/pages/Ui_Interface/Forms/Formmask";
//import Formvalidation from "../../views/pages/Ui_Interface/Forms/Formvalidation";
//import TablesBasic from "../../views/pages/Ui_Interface/Tables/TablesBasic";
//import DataTables from "../../views/pages/Ui_Interface/Tables/DataTables";
//import PerformanceIndicator from "../../views/pages/Performance/Performance/PerformanceIndicator";
//import PerformanceReview from "../../views/pages/Performance/Performance/PerformanceReview";
//import PerformanceAppraisal from "../../views/pages/Performance/Performance/PerformanceAppraisal";
//import GoalTracking from "../../views/pages/Performance/Goals/GoalTracking";
//import GoalType from "../../views/pages/Performance/Goals/GoalType";
//import Trainers from "../../views/pages/Performance/Training/Trainers";
//import Training from "../../views/pages/Performance/Training/Training";
//import TrainingType from "../../views/pages/Performance/Training/TrainingType";
import { useLocation } from "react-router-dom";
// import EmployeeProfile from "../../views/pages/Pages/profile/employeeprofile";
import AdminDashboard from "../../views/pages/MainPages/Dashboard/AdminDashboard/adminDashboard";
import EmployeeDashboard from "../../views/pages/MainPages/Dashboard/EmployeeDashboard";
//import Chat from "../../views/pages/MainPages/Apps/chat";
//import VoiceCall from "../../views/pages/MainPages/Apps/calls/voiceCall";
//import VideoCall from "../../views/pages/MainPages/Apps/calls/VideoCall";
//import Outgoing from "../../views/pages/MainPages/Apps/calls/outgoingCall";
//import IncomingCall from "../../views/pages/MainPages/Apps/calls/incomingCall";
//import Calendar from "../../views/pages/MainPages/Apps/calendar";
//import Contacts from "../../views/pages/MainPages/Apps/contacts";
//import Email from "../../views/pages/MainPages/Apps/Email";
//import FileManager from "../../views/pages/MainPages/Apps/FileManager";
//import Compose from "../../views/pages/MainPages/Apps/Email/compose";
//import Estimates from "../../views/pages/HR/Sales/Estimates";
//import CreateEstimate from "../../views/pages/HR/Sales/Estimates/createEstimate";
//import EditEstimate from "../../views/pages/HR/Sales/Estimates/EditEstimate";
//import Invoices from "../../views/pages/HR/Sales/Invoices/Index";
//import CreateInvoice from "../../views/pages/HR/Sales/Invoices/createInvoice";
//import EditInvoice from "../../views/pages/HR/Sales/Invoices/editInvoice";
//import InvoiceView from "../../views/pages/HR/Sales/Invoices/invoiceView";
//import Payments from "../../views/pages/HR/Sales/payments";
//import Promotion from "../../views/pages/Performance/Promotion";
//import Resignation from "../../views/pages/Performance/Resignation";
import Termination from "../../views/pages/Performance/Termination";
//import Components from "../../views/pages/Ui_Interface/Components/Components";
import Settings from "../../views/pages/Administration/Settings/Settings";
import Localization from "../../views/pages/Administration/Settings/Localization";
import ProfileSetting from "../../views/pages/Administration/Settings/ProfileSetting";
//import ThemeSettings from "../../views/pages/Administration/Settings/ThemeSettings";
//import RolesPermissions from "../../views/pages/Administration/Settings/RolesPermissions";
//import EmailSettings from "../../views/pages/Administration/Settings/EmailSettings";
//import PerformanceSetting from "../../views/pages/Administration/Settings/Performance/PerformanceSetting";
//import ApprovalSetting from "../../views/pages/Administration/Settings/ApprovalSetting";
//import InvoiceSettings from "../../views/pages/Administration/Settings/InvoiceSettings";
import SalarySettings from "../../views/pages/Administration/Settings/SalarySettings";
import NotificationSettings from "../../views/pages/Administration/Settings/NotificationSettings";
import LeaveType from "../../views/pages/Administration/Settings/LeaveType";
//import ToxboxSetting from "../../views/pages/Administration/Settings/ToxboxSetting";
//import CronSetting from "../../views/pages/Administration/Settings/CronSetting";
import AllEmpoyee from "../../views/pages/Employees/AllEmpoyee";
import Holidays from "../../views/pages/Employees/Holidays";
import AdminLeave from "../../views/pages/Employees/AdminLeave";
import Devices from "../../views/pages/Devices/Devices";
import DevicesLog from "../../views/pages/Devices/DevicesLogs";
import Locations from "../../views/pages/Locations/Locations";
import NSContact from "../../views/pages/Crm/NSContacts";
import EmployeeLeave from "../../views/pages/Employees/EmployeeLeave";
import LeaveSettings from "../../views/pages/Employees/LeaveSetting";
import LeaveBalances from "../../views/pages/Employees/LeaveBalance";
import EmployeeLeaveApplication from "../../views/pages/Employees/EmployeeLeaveApplication";
import LeaveTypes from "../../views/pages/Employees/LeaveType";
import AttendenceAdmin from "../../views/pages/Employees/Attendenceadmin";
import AttendanceEmployee from "../../views/pages/Employees/AttendenceEmployee";
import AttendenceEmployeeWeekly from "../../views/pages/Employees/AttendenceEmployeeWeekly";
import AttendenceEmployeeMonthly from "../../views/pages/Employees/AttendenceEmployeeMonthly";
import AttendanceDaily from "../../views/pages/Employees/AttendenceDaily";
import Department from "../../views/pages/Employees/Department";
import Designation from "../../views/pages/Employees/Designation";
import TimeSheet from "../../views/pages/Employees/TimeSheet";
import ShiftScheduling from "../../views/pages/Employees/ShiftandSchedule";
import ShiftList from "../../views/pages/Employees/ShiftList";
import OverTime from "../../views/pages/Employees/OverTime";
import Clients from "../../views/pages/Employees/Clients";
import Project from "../../views/pages/Employees/Projects/Project";
import ClientList from "../../views/pages/Employees/ClientList";
//import Tasks from "../../views/pages/Employees/Projects/Tasks";
import { SidebarProject } from "../../views/pages/Employees/Projects/SidebarProject";
//import TaskBoard from "../../views/pages/Employees/Projects/TaskBoard";
//import Leads from "../../views/pages/Employees/Leads";
//import Ticket from "../../views/pages/Employees/Ticket";
//import ClientProfile from "../../views/pages/Profile/ClientProfile";
import Profile from "../../views/pages/Profile/Profile";
//import Subscribtions from "../../views/pages/Subscribtions/Subscribtions";
import SubscribedCompany from "../../views/pages/Subscribtions/SubscribedCompany";
//import SubscribtionsCompany from "../../views/pages/Subscribtions/SubscribtionsCompany";
//import KnowledgeBase from "../../views/pages/Administration/Knowledgebase/KnowledgeBase";
import Login from "../../views/pages/Authentication/Login";
import EmployeeList from "../../views/pages/Employees/EmployeeList";
import Expenses from "../../views/pages/HR/Sales/Expenses";
import Activities from "../../views/pages/Administration/Activities";
//import ProvidentFund from "../../views/pages/HR/Sales/ProvidentFund";
//import Taxes from "../../views/pages/HR/Sales/Taxes";
//import Categories from "../../views/pages/HR/Accounting/Categories";
//import SubCategory from "../../views/pages/HR/Accounting/Categories/subCategory";
//import Budgets from "../../views/pages/HR/Accounting/Budgets.jsx";
//import BudgetExpenses from "../../views/pages/HR/Accounting/BudgetExpenses";
//import BudgetRevenues from "../../views/pages/HR/Accounting/BudgetRevenue";


import PayrollDashboard from "../../views/pages/MainPages/Dashboard/PayrollDashboard";


import EmployeeSalary from "../../views/pages/HR/Payroll/EmployeeSalary.jsx";
import RunPayroll from "../../views/pages/HR/Payroll/wrunPayroll.jsx";
import PayrollSetting from "../../views/pages/HR/Payroll/PayrollSetting.jsx";
import PaySlip from "../../views/pages/HR/Payroll/Payslip";
import PayrollItems from "../../views/pages/HR/Payroll/PayrollItems.jsx";
import PayrollHistory from "../../views/pages/HR/Payroll/PayrollHistory.jsx";
import PayrollReports from "../../views/pages/HR/Payroll/Reports/ReportPayrollLanding.jsx";
import OrgnizationSettings from "../../views/pages/Administration/Settings/OrgnizationSetting.jsx";
import ManageProperty from "../../views/pages/Administration/Settings/ManageProperty.jsx";
import GuestReservation from "../../views/pages/hms/guestReservation.jsx";
import FrontOfficeDashboard from "../../views/pages/hms/AdminDashboard/adminDashboard.jsx";
import ReservationCalandar from "../../views/pages/hms/reservationCalandar.jsx";
import RoomOverviewCalandar from "../../views/pages/hms/roomsOverview.jsx";
import FrontOfficeReports from "../../views/pages/hms/reports/front/ReportFrontOfficeLanding.jsx";
import RoomSoldDailyReport from "../../views/pages/hms/reports/front/RoomSoldDaily.jsx";
import DailyFlashReport from "../../views/pages/hms/reports/front/DailyFlashReport.jsx";
import ShiftEndSummary from "../../views/pages/hms/reports/front/ShiftEndSummary.jsx";
import SalesPerformance from "../../views/pages/hms/reports/front/SalesPerformance.jsx";
import ReservationReport from "../../views/pages/hms/reports/front/ReservationReport.jsx";
import OccupancyReport from "../../views/pages/hms/reports/front/OccupancyReport.jsx";
import RoomStatusReport from "../../views/pages/hms/reports/front/RoomStatusReport.jsx";
import OTABookingVolume from "../../views/pages/hms/reports/front/OtaBookings.jsx";
import OTABookingRevenue from "../../views/pages/hms/reports/front/OtaRevenue.jsx";
import GuestDatabase from "../../views/pages/hms/reports/front/GuestDatabase.jsx";
import GuestBillingSummary from "../../views/pages/hms/reports/front/GuestBillingSummary.jsx";
import DailyRevenueReport from "../../views/pages/hms/reports/front/DailyRevenue.jsx";
import PaymentModeReport from "../../views/pages/hms/reports/front/PaymentModeReport.jsx";
import RoomNoWiseSales from "../../views/pages/hms/reports/front/roomsold/RoomNoWiseSales.jsx";
import POSLandingeports from "../../views/pages/pos/reports/front/ReportPosLanding.jsx";
import POSDashboard from "../../views/pages/pos/AdminDashboard/posDashboard.jsx";
 
import DailySalesReport       from "../../views/pages/pos/reports/front/DailySalesReport.jsx";
import DatewiseSalesReport    from "../../views/pages/pos/reports/front/DatewiseSalesReport.jsx";
import SalesAnalysisReport    from "../../views/pages/pos/reports/front/SalesAnalysisReport.jsx";
import TaxReport              from "../../views/pages/pos/reports/front/TaxReport.jsx";
import ItemSalesReport        from "../../views/pages/pos/reports/front/ItemSalesReport.jsx";
import PendingKOTsReport      from "../../views/pages/pos/reports/front/PendingKOTsReport.jsx";
import ComplementaryItemsReport from "../../views/pages/pos/reports/front/ComplementaryItemsReport.jsx";
import ComplementaryBillsReport from "../../views/pages/pos/reports/front/ComplementaryBillsReport.jsx";
 


import ReservationListCard from "../../views/pages/hms/reservationListCard.jsx";
import ReservationList from "../../views/pages/hms/reservationList.jsx";
import ReservationDetails from "../../views/pages/hms/reservationDetails.jsx";
import PropertyConfiguration from "../../views/pages/hms/propertyCongiguration.jsx";
import GuestCard from "../../views/pages/hms/guestListCard.jsx";
import GuestCardDepature from "../../views/pages/hms/guestListDepatureCard.jsx";
import GuestCardCheckedOut from "../../views/pages/hms/guestListCheckedOutCard.jsx";
import InHouseGuestCard from "../../views/pages/hms/inHouseGuestCard.jsx";
import DayEndDashboard from "../../views/pages/hms/DayEndDashboard.jsx";
import DayEndDashboardPOS from "../../views/pages/pos/DayEndDashboard.jsx";
import DayBookPOS from "../../views/pages/pos/dayBook.jsx";
import ReservationPOS from "../../views/pages/pos/Reservation";
import ReservationWidget from "../../views/pages/pos/WidgetGenerator.jsx";
import DayBook from "../../views/pages/hms/dayBook.jsx";
import ProfileSettingHms from "../../views/pages/Administration/Settings/ProfileSettingHms";
import GuestCheckout from "../../views/pages/hms/guestCheckoutSummary.jsx";
import InvoiceList from "../../views/pages/hms/InvoiceList.jsx";
import CategoryList from "../../views/pages/pos/CategoryList.jsx";
import POSCounter from "../../views/pages/pos/BillingCounter.jsx";
import TableCounter from "../../views/pages/pos/BillingPage.jsx";
import TableOverview from "../../views/pages/pos/TableManagement.jsx";
import KotAdd from "../../views/pages/pos/KOTGenerationPage.jsx";
import TaxList from "../../views/pages/pos/TaxList.jsx";
import PosConfiguration from "../../views/pages/pos/posCongiguration.jsx";
import PosBillList from "../../views/pages/pos/PosBillsList.jsx";
import Marketing from "../../views/pages/pos/Marketing.jsx";
//import Offers from "../../views/pages/pos/Offers.jsx";
import FeedbackSetting from "../../views/pages/feedback/FeedbackSetting.jsx";
import FeedbackDashboard from "../../views/pages/feedback/reports/ReviewDashboard.jsx";
import FeedbackReports from "../../views/pages/feedback/reports/ReportFeedbackLanding.jsx";
import FeedbackIntegrations from "../../views/pages/feedback/integration.jsx";
import FeedbackOverviewReport from "../../views/pages/feedback/reports/FeedbackOverview.jsx";
import Engagement from "../../views/pages/engagement/NetshineApp.jsx";
import DigitalMenuConfiguration from "../../views/pages/digital-menu/menuconfig.jsx";

import BookingEngine from "../../views/pages/booking-engine/Dashboard.jsx";
import BookingEngineConfig from "../../views/pages/booking-engine/propertyCongiguration.jsx";
import BookingEngineSetting from "../../views/pages/booking-engine/ManageBookingEngine.jsx";
import BookingEngineGuest from "../../views/pages/booking-engine/BeBookingList.jsx";
import BookingEngineAllocations from "../../views/pages/booking-engine/BeRoomAllocation.jsx";
import BookingEngineOffers from "../../views/pages/booking-engine/BeOffers.jsx";
import BookingPaymentSetting from "../../views/pages/booking-engine/BePaymentSetting";
import BeManualInventoryCalendar  from "../../views/pages/booking-engine/BeManualInventoryCalendar.jsx";
import GuestDatabaseBookingEngine from "../../views/pages/booking-engine/reports/GuestDatabase.jsx";
import BookingEngineAnalytics from "../../views/pages/booking-engine/reports/Analytics.jsx";

import TableFlowReports from "../../views/pages/pos/reports/reservations/ReportLandingPage.jsx";
import BookingEnginePromoBanner from "../../views/pages/booking-engine/ManagePromoBanner.jsx";


import DynamicPriceDashboard from "../../views/pages/dynamic-price/DynamicPriceModule.jsx";


//import Policies from "../../views/pages/HR/Policies";
import Announcements from "../../views/pages/HR/Announcements";
//import ExpenseReport from "../../views/pages/HR/Reports/ExpenseReport";
//import InvoiceReport from "../../views/pages/HR/Reports/InvoiceReport";
//import PaymentReport from "../../views/pages/HR/Reports/PaymentReport";
//import ProjectReport from "../../views/pages/HR/Reports/ProjectReport";
//import TaskReport from "../../views/pages/HR/Reports/TaskReport";
//import UserReport from "../../views/pages/HR/Reports/UserReport";
//import EmployeeReport from "../../views/pages/HR/Reports/EmployeeReports";
//import PaySlipReports from "../../views/pages/HR/Reports/PaySlipReports";
//import AttendanceReport from "../../views/pages/HR/Reports/AttendanceReport";
//import LeaveReport from "../../views/pages/HR/Reports/LeaveReport";
//import DailyReports from "../../views/pages/HR/Reports/DailyReports";
import Assets from "../../views/pages/Administration/Assets";
import APISetting from "../../views/pages/Employees/ApiSetting";
// import UserDashboard from "../../views/pages/Administration/Jobs/UserJob/UserDashboard";
 //import UserAllJobs from "../../views/pages/Administration/Jobs/UserJob/UserAllJobs";
 //import SavedJobs from "../../views/pages/Administration/Jobs/UserJob/SavedJobs";
 //import AppliedJobs from "../../views/pages/Administration/Jobs/UserJob/AppliedJobs";
 //import Interviewing from "../../views/pages/Administration/Jobs/UserJob/Interviewing";
// import JobAptitude from "../../views/pages/Administration/Jobs/UserJob/JobAptitude";
// import Questions from "../../views/pages/Administration/Jobs/UserJob/Questions";
// import UserOfferedJobs from "../../views/pages/Administration/Jobs/UserJob/UserOfferedJobs";
// import VisitedJobs from "../../views/pages/Administration/Jobs/UserJob/VisitedJobs";
// import ArchivedJobs from "../../views/pages/Administration/Jobs/UserJob/ArchivedJobs";
// import JobsDashboard from "../../views/pages/Administration/Jobs/JobDashboard";
// import ManageJobs from "../../views/pages/Administration/Jobs/ManageJobs";
// import ManageJobResumes from "../../views/pages/Administration/Jobs/ManageResumes";
// import ShortListCandidates from "../../views/pages/Administration/Jobs/ShortListCandidates";
// import InterviewingQuestions from "../../views/pages/Administration/Jobs/InterviewingQuestions";
// import OfferApprovals from "../../views/pages/Administration/Jobs/OfferApprovals";
// import ExperienceLevel from "../../views/pages/Administration/Jobs/ExperienceLevel";
// import CanditatesList from "../../views/pages/Administration/Jobs/CanditatesList";
// import ScheduleTiming from "../../views/pages/Administration/Jobs/ScheduleTiming.jsx";
// import AptitudeResults from "../../views/pages/Administration/Jobs/AptitudeResults";
 import Users from "../../views/pages/Administration/Users";
// import ProjectList from "../../views/pages/Employees/Projects/ProjectList";
// import ProjectView from "../../views/pages/Employees/Projects/ProjectView";
import OffCanvas from "../../components/OffCanvas";
//import FormSelectTwo from "../../views/pages/Ui_Interface/Forms/FormSelectTwo.jsx";
//import FileUpload from "../../views/pages/Ui_Interface/Forms/FileUpload.jsx";
//import Ribbon from "../../views/pages/Ui_Interface/Elements/Ribbon.jsx";
//import Clipboard from "../../views/pages/Ui_Interface/Elements/Clipboard.jsx";
//import Dragdrop from "../../views/pages/Ui_Interface/Elements/Dragdrop.jsx";
//import Ratings from "../../views/pages/Ui_Interface/Elements/Rating.jsx";
//import Texteditor from "../../views/pages/Ui_Interface/Elements/Texteditor.jsx";
//import Counter from "../../views/pages/Ui_Interface/Elements/Counter.jsx";
//import Scrollbar from "../../views/pages/Ui_Interface/Elements/Scrollbar.jsx";
//import Notification from "../../views/pages/Ui_Interface/Elements/Notification.jsx";
//import Stickynotes from "../../views/pages/Ui_Interface/Elements/Stickynote.jsx";
//import Timeline from "../../views/pages/Ui_Interface/Elements/Timeline.jsx";
//import Formwizard from "../../views/pages/Ui_Interface/Elements/Formwizard.jsx";
//import Apexchart from "../../views/pages/Ui_Interface/Charts/Apexcharts.jsx";
//import ChartJs from "../../views/pages/Ui_Interface/Charts/Chartjs.jsx";
//import MorrisCharts from "../../views/pages/Ui_Interface/Charts/Morrischarts.jsx";
//import FlotCharts from "../../views/pages/Ui_Interface/Charts/Flotcharts.jsx";
//import PeityCharts from "../../views/pages/Ui_Interface/Charts/Peitycharts.jsx";
//import C3Charts from "../../views/pages/Ui_Interface/Charts/C3charts.jsx";
//import FontAwesomeicons from "../../views/pages/Ui_Interface/Icons/Fontawesomeicons.jsx";
//import FeatherIcons from "../../views/pages/Ui_Interface/Icons/Feathericons.jsx";
//import IonicIcon from "../../views/pages/Ui_Interface/Icons/Ionicicons.jsx";
//import MaterialIcons from "../../views/pages/Ui_Interface/Icons/Materialicons.jsx";
//import Pe7Icon from "../../views/pages/Ui_Interface/Icons/Pe7icons.jsx";
//import SimpleLine from "../../views/pages/Ui_Interface/Icons/Simpleicons.jsx";
//import Themifyicons from "../../views/pages/Ui_Interface/Icons/Themifyicons.jsx";
//import WeatherIcons from "../../views/pages/Ui_Interface/Icons/Weathericons.jsx";
//import Typicons from "../../views/pages/Ui_Interface/Icons/Typicons.jsx";
//import FlagIcons from "../../views/pages/Ui_Interface/Icons/Flagicons.jsx";
//import ContactList from "../../views/pages/Crm/ContactList.jsx";
//import ContactGrid from "../../views/pages/Crm/ContactGrid.jsx";
//import DealsDashboard from "../../views/pages/MainPages/Dashboard/DealsDashboard/index.jsx";
//import LeadsDashboard from "../../views/pages/MainPages/Dashboard/LeadsDashboard/index.jsx";
//import ComingSoon from "../../views/pages/Pages/ComingSoon.jsx";
//import TicketDetails from "../../views/pages/Employees/TicketDetails.jsx";
//import Companies from "../../views/pages/Crm/companies.jsx";
//import ContactDetails from "../../views/pages/Crm/ContactDetails.jsx";
//import LeadsList from "../../views/pages/Crm/LeadsList.jsx";
//import LeadsKanban from "../../views/pages/Crm/LeadsKanban.jsx";
//import LeadsDetails from "../../views/pages/Crm/LeadsDetails.jsx";
//import PipeLine from "../../views/pages/Crm/PipeLine.jsx";
//import CompaniesGrid from "../../views/pages/Crm/CompaniesGrid.jsx";
//import CompanyDetails from "../../views/pages/Crm/CompanyDetails.jsx";
//import Deals from "../../views/pages/Crm/Deals.jsx";
//import DealsKanban from "../../views/pages/Crm/DealsKanban.jsx";
//import Analytics from "../../views/pages/Crm/Analytics.jsx";
//import RecentFiles from "../../views/pages/MainPages/Apps/FileManager/recentFiles.jsx";
//import EmailContent from "../../views/pages/MainPages/Apps/Email/emailContent.jsx";
//import EmailView from "../../views/pages/MainPages/Apps/Email/emailView.jsx";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';

// Global Axios interceptor for responses/errors

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const currentPath = window.location.pathname;

    // ❌ Don't show Swal if already on login or public routes
    const isAuthPage = currentPath.startsWith("/login") || currentPath.startsWith("/signup");
    if (isAuthPage) {
      return Promise.reject(error); // just reject, no popups
    }

    if (!error.response) {
      // Network error: Backend down
      const retryHealthCheck = async () => {
        Swal.showLoading();
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_URL}/company/health-check`);
          if (res.status === 200 && res.data?.status === "ok") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Backend is now available!",
              confirmButtonText: "OK",
            });
            return true;
          } else {
            throw new Error("Health check failed");
          }
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "Retry Failed",
            text: "Backend is still unavailable. Try again?",
            showConfirmButton: true,
            confirmButtonText: "Retry",
            showCancelButton: true,
            cancelButtonText: "Logout",
          }).then((result) => {
            if (result.isConfirmed) {
              retryHealthCheck();
            } else {
              localStorage.removeItem("token");
              localStorage.removeItem("app_access");
              window.location.href = "/login?error=backend_issue";
            }
          });
          return false;
        }
      };

      Swal.fire({
        icon: "error",
        title: "Backend Unavailable",
        text: "The backend service is down. Click to check again.",
        confirmButtonText: "Check Again",
      }).then((result) => {
        if (result.isConfirmed) {
          retryHealthCheck();
        }
      });
    } else if (error.response.status === 401) {
      await Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your session has expired. Please log in again.",
        confirmButtonText: "OK",
      });
      //localStorage.removeItem("token");
      //localStorage.removeItem("app_access");
      ///window.location.href = "/login?error=session_expired";
    } else if (error.response.status === 500) {
      await Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "A server error occurred. Please try again later.",
        confirmButtonText: "OK",
      });
    }

    return Promise.reject(error);
  }
);

const AppContainer = () => {
  /*useEffect(() => {
    localStorage.setItem("colorschema", "orange");
    localStorage.setItem("layout", "vertical");
    localStorage.setItem("layoutwidth", "fixed");
    localStorage.setItem("layoutpos", "fluid");
    localStorage.setItem("topbartheme", "light");
    localStorage.setItem("layoutSized", "lg");
    localStorage.setItem("layoutStyling", "default");
    localStorage.setItem("layoutSidebarStyle", "dark");
  }, []);*/
  const location = useLocation(); // Get the current location (URL)
  const isHospitalityModule = location.pathname.startsWith("/hospitality");
  const isPosModule = location.pathname.startsWith("/pos");
  const isFeedbackModule = location.pathname.startsWith("/feedback");
  const isDigitalMenuModule = location.pathname.startsWith("/digital-menu");
  const isChannelManager = location.pathname.startsWith("/channel-manager");
  const isBookingEngine = location.pathname.startsWith("/booking-engine");
  const isTableFlowModule = location.pathname.startsWith("/table-flow");
  const isDynamicPrice = location.pathname.startsWith("/dynamic-price");



  const routingObjects = [
    
    {
      id: 2,
      path: "admin-dashboard",
      element: <AdminDashboard />,
    },
    {
      id: 17,
      path: "employee-dashboard",
      element: <EmployeeDashboard />,
    },
    
    // {
    //   id: 20,
    //   path: "profile",
    //   element: <EmployeeProfile />,
    // },
    {
      id: 34,
      path: "termination",
      element: <Termination />,
    },
    {
      id: 34,
      path: "employees",
      element: <AllEmpoyee />,
    },
    {
      id: 35,
      path: "holidays",
      element: <Holidays />,
    },
    {
      id: 36,
      path: "adminleaves",
      element: <AdminLeave />,
    },
    {
      id: 36,
      path: "devices",
      element: <Devices />,
    },
    {
      id: 360,
      path: "deviceslog",
      element: <DevicesLog />,
    },
    
        {
      id: 360,
      path: "nscontacts",
      element: <NSContact />,
    },
    {
      id: 360,
      path: "manage-locations",
      element: <Locations />,
    },
    
    {
      id: 37,
      path: "leaves-employee",
      element: <EmployeeLeave />,
    },
    {
      id: 38,
      path: "leave-settings",
      element: <LeaveSettings />,
    },
    {
      id: 38,
      path: "leaves-balance",
      element: <LeaveBalances />,
    },
    
    {
      id: 38,
      path: "leave-applications",
      element: <EmployeeLeaveApplication />,
    },
    
    {
      id: 39,
      path: "adminattendance",
      element: <AttendenceAdmin />,
    },
    {
      id: 40,
      path: "attendance-employee",
      element: <AttendanceEmployee />,
    },
    {
      id: 40,
      path: "attendance-weekly",
      element: <AttendenceEmployeeWeekly />,
    },
    
    {
      id: 40,
      path: "attendance-monthly",
      element: <AttendenceEmployeeMonthly />,
    },
    {
      id: 40,
      path: "attendance-daily",
      element: <AttendanceDaily />,
    },
    {
      id: 41,
      path: "departments",
      element: <Department />,
    },
    {
      id: 42,
      path: "designations",
      element: <Designation />,
    },
    {
      id: 43,
      path: "timesheet",
      element: <TimeSheet />,
    },
    {
      id: 43,
      path: "shift-scheduling",
      element: <ShiftScheduling />,
    },
    {
      id: 44,
      path: "shift-list",
      element: <ShiftList />,
    },
    {
      id: 40,
      path: "api-settings",
      element: <APISetting />,
    },
    {
      id: 45,
      path: "overtime",
      element: <OverTime />,
    },
    {
      id: 46,
      path: "clients",
      element: <Clients />,
    },
    {
      id: 47,
      path: "projects",
      element: <Project />,
    },
    {
      id: 47,
      path: "login",
      element: <Login />,
    },
    
    {
      id: 53,
      path: "profile/:userId", // Add a dynamic parameter for the user ID
      element: <Profile />,
    },
   // {
    //  id: 54,
     // path: "subscriptions",
    //  element: <Subscribtions />,
   // },
    {
      id: 55,
      path: "subscribed-companies",
      element: <SubscribedCompany />,
    },
   /* {
      id: 56,
      path: "subscriptions-company",
      element: <SubscribtionsCompany />,
    },*/
    
 
    {
      id: 64,
      path: "employees-list",
      element: <EmployeeList />,
    },
    {
      id: 65,
      path: "expenses",
      element: <Expenses />,
    },
    {
      id: 73,
      path: "salary-view",
      element: <PaySlip />,
    },
    {
      id: 74,
      path: "payroll-items",
      element: <PayrollItems />,
    },
    {
      id: 74,
      path: "payroll-settings",
      element: <PayrollSetting />,
    },
    
    {
      id: 74,
      path: "payroll-history",
      element: <PayrollHistory />,
    },
    
    {
      id: 74,
      path: "payroll-reports",
      element: <PayrollReports />,
    },
    
    
    
    {
      id: 75,
      path: "announcements",
      element: <Announcements />,
    },
    
    {
      id: 76,
      path: "run-payroll",
      element: <RunPayroll />,
    },

    {
      id: 76,
      path: "payroll-overview",
      element: <PayrollDashboard />,
    },

    
    {
      id: 76,
      path: "salary",
      element: <EmployeeSalary />,
    },
 
    {
      id: 132,
      path: "localization",
      element: <Localization />,
    },
    {
      id: 142,
      path: "account-setting",
      element: <ProfileSettingHms />,
    },
    
    {
      id: 142,
      path: "hospitality/account-setting",
      element: <ProfileSettingHms />,
    },

        {
      id: 142,
      path: "digital-menu/account-setting",
      element: <ProfileSettingHms />,
    },

        {
      id: 142,
      path: "booking-engine/account-setting",
      element: <ProfileSettingHms />,
    },

        {
      id: 142,
      path: "pos/account-setting",
      element: <ProfileSettingHms />,
    },
    {
      id: 132,
      path: "notifications-settings",
      element: <NotificationSettings />,
    },
    {
      id: 133,
      path: "company-settings",
      element: <OrgnizationSettings />,
    },
    {
      id: 133,
      path: "manage-property",
      element: <ManageProperty />,
    },


            {
      id: 133,
      path: "hospitality/manage-property",
      element: <ManageProperty />,
    },


        {
      id: 133,
      path: "booking-engine/manage-property",
      element: <ManageProperty />,
    },

            {
      id: 133,
      path: "pos/manage-property",
      element: <ManageProperty />,
    },
        {
      id: 133,
      path: "digital-menu/manage-property",
      element: <ManageProperty />,
    },

    {
      id: 133,
      path: "hospitality/guest-reservation",
      element: <GuestReservation />,
    },
    
    {
      id: 133,
      path: "hospitality/reservation-details/:id", // ✅ Support dynamic booking ID
      element: <ReservationDetails />,
    },
    
    {
      id: 133,
      path: "hospitality/reservation-list", // ✅ Support dynamic booking ID
      element: <ReservationList />,
    },
    
    {
      id: 133,
      path: "hospitality/reservation-list-card", // ✅ Support dynamic booking ID
      element: <    ReservationListCard />,
    },
    {
      id: 133,
      path: "hospitality/day-book", // ✅ Support dynamic booking ID
      element: <    DayBook />,
    },
    {
      id: 133,
      path: "hospitality/property-configuration",
      element: <PropertyConfiguration />,
    },
    {
      id: 133,
      path: "hospitality/guest-list-card",
      element: <GuestCard />,
    },
    {
      id: 133,
      path: "hospitality/list-depature-guest-card",
      element: <GuestCardDepature />,
    },
    {
      id: 133,
      path: "hospitality/list-checkedout-guest-card",
      element: <GuestCardCheckedOut />,
    },
    {
      id: 133,
      path: "hospitality/inhouse-guest",
      element: <InHouseGuestCard />,
    },
    
    
    {
      id: 133,
      path: "hospitality/day-end",
      element: <DayEndDashboard />,
    },
    
    {
      id: 133,
      path: "hospitality/day-invoices",
      element: <InvoiceList />,
    },
    
    {
      id: 133,
      path: "hospitality/",
      element: <FrontOfficeDashboard />,
    },
    {
      id: 133,
      path: "hospitality/calandar",
      element: <ReservationCalandar />,
    },
    {
      id: 133,
      path: "hospitality/room-overview",
      element: <RoomOverviewCalandar />,
    },
    
    {
      id: 134,
      path: "hospitality/reports",
      element: <FrontOfficeReports/>,
    },
        {
      id: 134,
      path: "pos/reports",
      element: <POSLandingeports/>,
    },


        {
      id: 134,
      path: "pos/reports/daily-sales",
      element: <DailySalesReport />,
    },
    {
      id: 134,
      path: "pos/reports/datewise-sales",
      element: <DatewiseSalesReport />,
    },
    {
      id: 134,
      path: "pos/reports/sales-analysis",
      element: <SalesAnalysisReport />,
    },
    {
      id: 134,
      path: "pos/reports/tax-report",
      element: <TaxReport />,
    },
    {
      id: 134,
      path: "pos/reports/item-sales",
      element: <ItemSalesReport />,
    },
    {
      id: 134,
      path: "pos/reports/pending-kots",
      element: <PendingKOTsReport />,
    },
    {
      id: 134,
      path: "pos/reports/complementary-items",
      element: <ComplementaryItemsReport />,
    },
    {
      id: 134,
      path: "pos/reports/complementary-bills",
      element: <ComplementaryBillsReport />,
    },
 

            {
      id: 134,
      path: "pos/pos-dashboard",
      element: <POSDashboard/>,
    },
    
    {
      id: 134,
      path: "hospitality/daily-room-sold",
      element: <RoomSoldDailyReport/>,
    },
    {
      id: 134,
      path: "hospitality/daily-flash-report",
      element: <DailyFlashReport/>,
    },
    {
      id: 134,
      path: "hospitality/shift-end-summary",
      element: <ShiftEndSummary/>,
    },
    
    {
      id: 134,
      path: "hospitality/sales-performance",
      element: <SalesPerformance/>,
    },
    {
      id: 134,
      path: "hospitality/reservation-report",
      element: <ReservationReport/>,
    },
    {
      id: 134,
      path: "hospitality/occupancy-report",
      element: <OccupancyReport/>,
    },
    {
      id: 134,
      path: "hospitality/room-status-report",
      element: <RoomStatusReport/>,
    },
    
    {
      id: 134,
      path: "hospitality/ota-booking-volume",
      element: <OTABookingVolume/>,
    },
    
    {
      id: 134,
      path: "hospitality/ota-booking-revenue",
      element: <OTABookingRevenue/>,
    },
    
        {
      id: 134,
      path: "hospitality/guest-database",
      element: <GuestDatabase/>,
    },
        {
      id: 134,
      path: "hospitality/front-office-billings",
      element: <GuestBillingSummary/>,
    },
    
        {
      id: 134,
      path: "hospitality/daily-revenue-analysis",
      element: <DailyRevenueReport/>,
    },
        {
      id: 134,
      path: "hospitality/payment-mode-report",
      element: <PaymentModeReport/>,
    },
        {
      id: 134,
      path: "hospitality/roomno-wise-sales",
      element: <RoomNoWiseSales/>,
    },
    {
      id: 134,
      path: "pos/category-list",
      element: <CategoryList/>,
    },
 
    {
      id: 134,
      path: "hospitality/pos-counter",
      element: <POSCounter/>,
    },  
 
    
    {
      id: 134,
      path: "hospitality/table-counter",
      element: <TableCounter/>,
    },  
    {
      id: 134,
      path: "pos/table-overview",
      element: <TableOverview/>,
    },  
    {
      id: 134,
      path: "pos/kot-add",
      element: <KotAdd/>,
    },  
    {
      id: 134,
      path: "pos/tax-list",
      element: <TaxList/>,
    },
    {
      id: 133,
      path: "pos/",
      element: <TableOverview/>,
    },
    {
      id: 133,
      path: "pos/pos-configuration",
      element: <PosConfiguration/>,
    },
  {
      id: 133,
      path: "pos/bill-list",
      element: <PosBillList/>,
    },

  {
      id: 133,
      path: "pos/marketing",
      element: <Marketing/>,
    },



    
         {
      id: 133,
      path: "feedback/engagement",
      element: <Engagement/>,
    },




    

     {
      id: 133,
      path: "feedback/",
      element: <FeedbackDashboard/>,
    },

    
     {
      id: 133,
      path: "feedback/feedback-setting",
      element: <FeedbackSetting/>,
    },


         {
      id: 133,
      path: "feedback/feedback-responses",
      element: <FeedbackResponses/>,
    },

  
         {
      id: 133,
      path: "feedback/feedback-reports",
      element: <FeedbackReports/>,
    },  

         {
      id: 133,
      path: "feedback/feedback-reports/overview",
      element: <FeedbackOverviewReport/>,
    },  

    


             {
      id: 133,
      path: "feedback/feedback-integrations",
      element: <FeedbackIntegrations/>,
    },  

    {
      id: 133,
      path: "pos/day-end",
      element: <DayEndDashboardPOS />,
    },
      {
      id: 133,
      path: "pos/day-book",
      element: <DayBookPOS />,
    },
      {
      id: 133,
      path: "pos/reservations",
      element: <ReservationPOS />,
    },
        {
      id: 133,
      path: "pos/generate-widget",
      element: <ReservationWidgetFront />,
    },
       {
      id: 133,
      path: "table-flow/admin-reservation",
      element: <AdminReservation />,
    },

           {
      id: 133,
      path: "table-flow/waitlist",
      element: <WaitlistPage />,
    },
    
        {
      id: 133,
      path: "pos/reservation-widget",
      element: <ReservationWidget />,
    },


  {
      id: 133,
      path: "table-flow/reviews/:source",
      element: <FeedbackDashboard/>,
    },

    
  {
      id: 133,
      path: "table-flow/reports",
      element: <TableFlowReports/>,
    },

    
     {
      id: 133,
      path: "feedback/feedback-setting",
      element: <FeedbackSetting/>,
    },


         {
      id: 133,
      path: "feedback/feedback-responses",
      element: <FeedbackResponses/>,
    },

  
         {
      id: 133,
      path: "feedback/feedback-reports",
      element: <FeedbackReports/>,
    },  

         {
      id: 133,
      path: "feedback/feedback-reports/overview",
      element: <FeedbackOverviewReport/>,
    },  

            {
      id: 133,
      path: "table-flow/digital-menu/:source",
      element: <DigitalMenuConfiguration/>,
    },


             {
      id: 133,
      path: "feedback/feedback-integrations",
      element: <FeedbackIntegrations/>,
    },  

        {
      id: 133,
      path: "digital-menu/",
      element: <DigitalMenuConfiguration/>,
    },


            {
      id: 133,
      path: "booking-engine/",
      element: <BookingEngine/>,
    },


              {
      id: 133,
      path: "booking-engine/promo-banners",
      element: <BookingEnginePromoBanner/>,
    },
     
     
     {
      id: 133,
      path: "booking-engine/layout/",
      element: <BookingEngineSetting/>,
    },

            {
      id: 133,
      path: "booking-engine/booking-engine-config/",
      element: <BookingEngineConfig/>,
    },
      
            {
      id: 133,
      path: "channel-manager/property/",
      element: <BookingEngineConfig/>,
    },


                {
      id: 133,
      path: "channel-manager/bookings",
      element: <BookingDashboard/>,
    },

     
                {
      id: 133,
      path: "booking-engine/bookings/",
      element: <BookingEngineGuest/>,
    },


    
                {
      id: 133,
      path: "booking-engine/payment-setting/",
      element: <BookingPaymentSetting/>,
    },
      
                {
      id: 133,
      path: "booking-engine/allocations/",
      element: <BookingEngineAllocations/>,
    },


                    {
      id: 133,
      path: "booking-engine/offers/",
      element: <BookingEngineOffers/>,
    },

                    {
      id: 133,
      path: "booking-engine/manual-inventory/",
      element: <BeManualInventoryCalendar/>,
    },

                    {
      id: 133,
      path: "booking-engine/guests/",
      element: <GuestDatabaseBookingEngine/>,
    },

                        {
      id: 133,
      path: "booking-engine/analytics/",
      element: <BookingEngineAnalytics/>,
    },

    {
      id: 133,
      path: "dynamic-price/",
      element: <DynamicPriceDashboard/>,
    },

    

        {
      id: 133,
      path: "channel-manager/",
      element: <ChannelManagerLanding/>,
    },

        {
      id: 133,
      path: "channel-manager/setup",
      element: <ChannelManagerSetup/>,
    },

            {
      id: 133,
     path: "channel-manager/channel-settings/:id",
      element: <ChannelSettings/>,
    },
        {
      id: 133,
      path: "channel-manager/ota-settings",
      element: <OTAChannelSetup/>,
    },

            {
      id: 133,
      path: "channel-manager/list-channels",
      element: <ChannelManagerHome/>,
    },

  

    {
  id: 134,
  path: "channel-manager/ari/:id",
  element: <AriGridPage />,
},

      {
      id: 133,
      path: "table-flow/",
      element: <ReservationPOS />,
    },

        {
      id: 133,
      path: "table-flow/configuration",
      element: <PosConfiguration/>,
    },
    
  ];
  const SettingsRoutingeObjects = [
    {
      id: 1,
      path: "company-settings",
      element: <Settings />,
    },
    
    {
      id: 11,
      path: "leave-type",
      element: <LeaveType />,
    },
  ];
  const AdministrationRoutingeObjects = [
    {
      id: 1,
      path: "assets",
      element: <Assets />,
    },
    
    {
      id: 23,
      path: "device-users",
      element: <Users />,
    },
  ];


  
const SidebarLayout = () => {
  // ✅ Keep your existing booleans (assumed already computed in this component)
  // const isPosModule = ...
  // const isHospitalityModule = ...
  // const isFeedbackModule = ...
  // const isDigitalMenuModule = ...
  // const isChannelManager = ...
  // const isBookingEngine = ...
  // const isTableFlowModule = ...

  // ✅ Order matters: first TRUE wins (keeps current behavior deterministic)
  const modules = [
    {
      key: "pos",
      when: isPosModule,
      Header: HeaderPos,
      Sidebar: PosSidebar,
    },
    {
      key: "hms",
      when: isHospitalityModule,
      Header: HeaderHms,
      Sidebar: HospitalitySidebar,
    },
    {
      key: "feedback",
      when: isFeedbackModule,
      Header: HeaderFeedback,
      Sidebar: FeedbackSidebar,
    },
    {
      key: "digitalMenu",
      when: isDigitalMenuModule,
      Header: HeaderDigitalMenu,
      Sidebar: DigitalMenuSidebar,
    },
    {
      key: "channelManager",
      when: isChannelManager,
      Header: HeaderChannelManager,
      Sidebar: ChannelManagerSidebar,
    },
    {
      key: "bookingEngine",
      when: isBookingEngine,
      Header: HeaderBookingEngine,
      Sidebar: BookingEngineSidebar,
    },

    // ✅ NEW: Table Flow module (added at the end to avoid impacting existing priority)
    // If you want Table Flow to override some modules, move this object higher.
    {
      key: "tableFlow",
      when: isTableFlowModule,
      Header: HeaderTableFlow,
      Sidebar: SidebarTableFlow,
    },

        {
      key: "dynamicPrice",
      when: isDynamicPrice,
      Header: HeaderDynamicPrice,
      Sidebar: SidebarDynamicPrice,
    },
  ];

  const active = modules.find((m) => !!m.when);

  const ActiveHeader = active?.Header || Header;
  const ActiveSidebar = active?.Sidebar || Sidebar;

  return (
    <>
      <ActiveHeader />
      <ActiveSidebar />
      <OffCanvas />
      <Outlet />
    </>
  );
};



  const AuthendicationLayout = () => (
    <div>
     
    </div>
  );
  const SettingsSidebarLayout = () => (
    <>
      <Header />
      <SettingsSidebar />
      <Outlet />
    </>
  );
 
  const mobileResponsive = (event) => {
    const excludedHeader = document.querySelector(".header");
    const excludedSidebar = document.querySelector(".sidebar");
    if (
      !excludedHeader.contains(event.target) &&
      !excludedSidebar.contains(event.target)
    ) {
      document.body.classList.remove("slide-nav");
    }
  };
  return (
    <>
<div className="main-wrapper">
  <Routes>
    {/* Public */}
    <Route path="/login" element={<Login />} />

    {/* Protected */}
    <Route element={<PrivateRoute />}>
      {/* Main shell routes (SidebarLayout) */}
      <Route path="/*" element={<SidebarLayout />}>
        {routingObjects.map((item) => (
          <Route key={item.id} path={item.path} element={item.element} />
        ))}

        {AdministrationRoutingeObjects.map((item) => (
          <Route key={item.id} path={item.path} element={item.element} />
        ))}

        {/* Catch-all inside authenticated shell */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>

      {/* Settings shell routes (SettingsSidebarLayout) */}
      <Route path="/*" element={<SettingsSidebarLayout />}>
        {SettingsRoutingeObjects.map((item) => (
          <Route key={item.id} path={item.path} element={item.element} />
        ))}
      </Route>
    </Route>
  </Routes>
</div>
    </>
  );
};
export default AppContainer;